import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from '@/components/ui/card';

import { ImportTypeTable } from './import-type/table';

export function Admin() {
	return (
		<>
			<Card className="w-full">
				<CardHeader>
					<span className="flex flex-row justify-between">
						<CardTitle className="mt-2">Import Types</CardTitle>
					</span>
				</CardHeader>
				<CardContent className="space-y-2">
					<ImportTypeTable />
				</CardContent>
			</Card>
		</>
	);
}
